import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import CustomersPowerSelect from '../../customers/customers-power-select.jsx';
import JobsTable from '../../jobs/jobs-table.jsx';


export default class SystemFixCustomers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            selectedCustomerId: null,
            jobId: null,
            url: props.url || '/api/v1/portal/portal-admin/system-fix-customers/jobs-for-customer',
            postUrl: '/api/v1/portal/portal-admin/system-fix-customers/set-jobs-customer/{customer}',
            jobs: null,
            disableSubmitButtom: false,
        };

        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
        this.handleChangeCustomer = this.handleChangeCustomer.bind(this);
        this.handleShowExistingCustomerOfJob = this.handleShowExistingCustomerOfJob.bind(this);
    }

    componentDidMount() {
        this.setState({
            isLoading: false
        })
    }

    handleCustomerSelection(option) {
        this.setState({ selectedCustomerId: option.id, customerName: option.name });
    }
    handleChangeCustomer() {
        this.setState({ disableSubmitButtom: true });
        if (confirm('Are yopu sure Following jobs belongs to customer "' + this.state.customerName + '" ?')) {
            let postUrl = this.state.postUrl.replace('{customer}', this.state.selectedCustomerId);
            let jobsId = this.state.jobs.map((job) => job.id);
            fetch(`${postUrl}`, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Authorization": `Bearer ${window.api_token}`,
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    jobsId: jobsId,
                })
            })
                .then(res => res.json())
                .then(response => {
                    this.setState({
                        jobs: response,
                        isLoading: false,
                        disableSubmitButtom: false
                    });
                })
                .catch(err => {
                    console.error("Fetch error:", err);
                    this.setState({
                        isLoading: false,
                        disableSubmitButtom: true
                    });
                    alert('Something went wrong!');
                });
        }
    }
    handleShowExistingCustomerOfJob(e) {
        const jobId = e.target.value;

        this.setState({ jobId }, () => {
            console.log("Updated jobId:", this.state.jobId);
            clearTimeout(this.debounceFetch);
            this.debounceFetch = setTimeout(() => {
                fetch(`${this.state.url}/${this.state.jobId}`, {
                    method: "GET",
                    mode: "cors",
                    cache: "no-cache",
                    credentials: "same-origin",
                    headers: {
                        "Authorization": `Bearer ${window.api_token}`,
                        "Accept": "application/json"
                    },
                })
                    .then(res => res.json())
                    .then(response => {
                        this.setState({
                            jobs: response,
                            isLoading: false
                        });
                    })
                    .catch(err => console.error("Fetch error:", err));
            }, 1000);
        });

    }
    render() {
        return (
            (this.state.isLoading) ?
                (<span className="add-loading-text">
                    <i className="fa fa-spinner fa-pulse"></i></span>) :
                <div>
                    <div className="row">
                        <div className="offset-md-4 col-sm-12">
                            <h2>System Settings</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-md-4 col-md-4 col-sm-12">
                            <label>
                                Customers
                            </label>
                            <CustomersPowerSelect handleCustomerSelection={this.handleCustomerSelection} />
                        </div>
                        {this.state.selectedCustomerId ? <div className="col-md-2">
                            <a className="btn btn-light btn-sm"
                                href={"/jobs/customer/" + this.state.selectedCustomerId} target="_blank">
                                <i className="fa fa-road"></i> All Jobs of "{this.state.customerName}"" <i
                                    className="fa fa-arrow-right"></i>
                            </a>
                        </div> : ''}
                    </div>
                    <div className="row">
                        <div className="offset-md-4 col-md-4 col-sm-12">
                            <label>
                                Jobs
                            </label>
                            <input type="text" className="form-control form-control-lg" name="job_reference_number"
                                onChange={this.handleShowExistingCustomerOfJob} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-md-4 col-md-4 col-sm-12 text-center">
                            <button disabled={this.state.disableSubmitButtom} className="btn btn-primary mt-2" onClick={this.handleChangeCustomer}>
                                {this.state.disableSubmitButtom ? (<span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span>) : ''} 
                                Fix Customer id for below jobs</button>
                        </div>
                    </div>
                    <hr />
                    {this.state.jobs ? <JobsTable jobs={this.state.jobs} /> : ''}
                </div>
        );
    }
}
if (document.getElementById(
    'react-component-g4-logistics-portal-portal-admin-system-fix-customers')) {
    ReactDOM.render(
        <SystemFixCustomers
            message_if_none='No Customers found. Add one to see it here.'
        />,
        document.getElementById(
            'react-component-g4-logistics-portal-portal-admin-system-fix-customers'
        )
    );
}